import { render, staticRenderFns } from "./Import&Export.vue?vue&type=template&id=3c3abc48&scoped=true&"
import script from "./Import&Export.vue?vue&type=script&lang=js&"
export * from "./Import&Export.vue?vue&type=script&lang=js&"
import style0 from "./Import&Export.vue?vue&type=style&index=0&id=3c3abc48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3abc48",
  null
  
)

export default component.exports